import React, { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import {
  useNotify,
  SimpleForm,
  RadioButtonGroupInput,
  NumberInput,
  useRefresh,
  ReferenceInput,
  SelectInput,
} from "react-admin";
import { useWatch } from "react-hook-form";
import { fetchPermissions, fetchUserData } from "../../../auth/security/authProvider";
import { getUser, setUser } from "../../../auth/security/securityUtils";
import dataProvider from "server/dataProvider/dataProvider";
import { accountRequests } from "api/accountApi";
import { employeeRequests } from "api/employeeApi";

const LoginChoiceFields = ({ setUserId, setEmployeeId }) => {
  const mode = useWatch({ name: "mode", defaultValue: "allUsers" });
  const allEmployeeIDs = useWatch({ name: "allEmployeeIDs" });
  const sessionId = useWatch({ name: "sessionId" });
  const employeeId = useWatch({ name: "employeeId" });

  useEffect(() => {
    const map = { allUsers: allEmployeeIDs, sessionID: sessionId };
    setUserId(map[mode]);
  }, [mode, allEmployeeIDs, sessionId, employeeId, setUserId]);

  useEffect(() => {
    setEmployeeId(employeeId);
  }, [employeeId, setEmployeeId]);

  return (
    <Grid container>
      <h3>Опции за логване като друг потребител</h3>
      <Grid
        xs={12}
        item
      >
        <div>В момента сте логнат със сесия: {localStorage.getItem("access_token")} </div>
        <div>sessionID: {JSON.parse(JSON.parse(localStorage.userData)).userId}</div>
        <div>employeeID: {JSON.parse(JSON.parse(localStorage.userData)).employeeId}</div>
      </Grid>
      <Grid
        xs={12}
        sm={2}
        item
      >
        <RadioButtonGroupInput
          source="mode"
          label=""
          sx={{ "& .MuiFormGroup-root label:not(:first-child)": { marginTop: "45px" } }}
          defaultValue={mode}
          choices={[
            { id: "allUsers", name: "От всички възможни" },
            { id: "sessionID", name: "По sessionID" },
            { id: "employeeID", name: "По employeeID" },
          ]}
        />
      </Grid>
      <Grid
        xs={12}
        sm={10}
        item
      >
        <ReferenceInput
          source="allEmployeeIDs"
          reference={employeeRequests.getEmployeesSelect()}
        >
          <SelectInput
            label="Всички потребители"
            optionValue="userId"
            optionText={record =>
              `${record.firstName} ${record.lastName} [session: ${record.userId}] [employee: ${record.id}]`
            }
            disabled={mode !== "allUsers"}
          />
        </ReferenceInput>
        <NumberInput
          source="sessionId"
          disabled={mode !== "sessionID"}
          label="sessionID"
        />
        <NumberInput
          source="employeeId"
          disabled={mode !== "employeeID"}
          label="employeeID"
        />
      </Grid>
    </Grid>
  );
};

const SuperLogin = () => {
  function updateUserNames(resolvedUserData) {
    if (resolvedUserData) {
      setUser(
        JSON.stringify({
          ...JSON.parse(getUser()),
          given_name: resolvedUserData.firstName,
          family_name: resolvedUserData.lastName,
        }),
      );
    }
  }

  const [userId, setUserId] = useState(null);
  const [employeeId, setEmployeeId] = useState(null);
  const refresh = useRefresh();
  const notify = useNotify();
  const handleSuperLogin = async () => {
    let url = "";
    let resolvedUserData = null;
    try {
      if (userId) {
        const { data: userData } = await dataProvider.customRequest(accountRequests.getUserById(userId), null, "GET");
        url = accountRequests.getSuperLoginByUserId(userId);
        resolvedUserData = userData;
      } else if (employeeId) {
        const { data: employeeData } = await dataProvider.customRequest(
          employeeRequests.getEmployeeById(employeeId),
          null,
          "GET",
        );
        url = accountRequests.getSuperLoginByUserId(employeeData?.userId);
        resolvedUserData = employeeData?.userInfo;
      }
      const { data } = await dataProvider.customRequest(url, null, "GET");

      url = ``;
      if (data.sessionId) {
        localStorage.setItem("access_token", data.sessionId);
        await fetchUserData();
        updateUserNames(resolvedUserData);
        notify(`Успешно се логнахте с ID:${userId}`, { type: "success" });
        await fetchPermissions();
        const notifyMessage = resolvedUserData
          ? `Успешно обновихте правата си с тези на потребител ${resolvedUserData.firstName} ${resolvedUserData.lastName}`
          : `Успешно обновихте правата си с тези на потребител с ID:${userId}`;

        notify(notifyMessage, { type: "success" });

        refresh();
      }
    } catch (e) {
      console.error("Super login failed", e);
      notify("Възникна грешка при изпращане на заявката", { type: "error" });
    }
  };

  return (
    <SimpleForm onSubmit={handleSuperLogin}>
      <LoginChoiceFields
        setUserId={setUserId}
        setEmployeeId={setEmployeeId}
      />
    </SimpleForm>
  );
};
export default SuperLogin;
